<template>
  <jtCard
    containerHeight="429"
    title="车辆进出情况"
    style="margin-bottom: 30px"
  >
    <div class="container">
      <div
        class="chart"
        id="containercar"
        style="width: 100%; height: 350px"
      ></div>
      <!-- <div v-else>暂无数据</div> -->
    </div>
  </jtCard>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
import jtCard from "@/components/Card";
export default {
  components: {
    jtCard,
  },
  props: {
    tbVehicleAccessList: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    let _this = this;
    // 在mouted里面做了一个立即执行函数 ，防止里面的变量污染
    (function () {
      //下面和eacharts差不多
      const container = document.getElementById("containercar");
      const myChart = new Charts(container);
      var option = {
        title: {
          show: false,
        },
        legend: {
          top: 40,
          textStyle: {
            fill: "#fff",
            fontSize: 20,
          },
          data: [
            { name: "今日进", color: "#5267FF" },
            { name: "今日出", color: "#35E9FB" },
          ],
        },
        xAxis: {
          data: _this.tbVehicleAccessList.documentDate,
          // data: [
          //   "Jan",
          //   "Feb",
          //   "Mar",
          //   "Apr",
          //   "May",
          //   "Jun",
          //   "Jul",
          //   "Aug",
          //   "Sep",
          //   "Oct",
          //   "Nov",
          //   "Dec",
          // ],
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
        },
        yAxis: {
          data: "value",
          min:0,
          splitLine:{
            show: false
          },
          axisLine: {
            style: {
              borderType: "dashed",
            },
          },
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
        },
        series: [
          {
            name: "今日进",
            // data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4,3.3],
            data: _this.tbVehicleAccessList.inToday,
            type: "bar",
            gradient: {
              color: ["#046EDB","#47D9EF"],
            },
          },
          {
            // background: linear-gradient(0deg, #FD5F02, #FD8B02);
            name: "今日出",
            data: _this.tbVehicleAccessList.outToday,

            // data: [
            //   2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0,
            //   2.3,
            // ],
            type: "bar",
            gradient: {
              // background: linear-gradient(0deg, #3CFFFD 0%);
              color: ["#3CFFFD", "#fff"],
            },
          }
        ],
      };

      myChart.setOption(option);
    })();
  },
  methods: {},
};
</script>
<style scoped>
.container{
}
.chart {
  height: 240px;
  margin-left: 15px;
}

h2 {
  height: 48px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 48px;
}
</style>

